<template>
  <svg
    width="70"
    height="32"
    viewBox="0 0 70 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_4154_49832)">
      <path
        d="M12.2169 28.3339H11.2905L11.4211 27.7373H13.9483L13.823 28.3339H12.8967L12.3434 30.9215H11.6642L12.2169 28.3339Z"
        fill="#212121"
      />
      <path
        d="M15.165 29.7807H14.6376L14.3957 30.922H13.7212L14.405 27.7378H15.7594C16.2723 27.7378 16.7394 28.0814 16.7421 28.6354C16.7447 29.2134 16.3571 29.6475 15.8442 29.7428L16.2868 30.922H15.5407L15.165 29.7807ZM16.0344 28.7013C16.0331 28.4769 15.8475 28.3191 15.6289 28.3191H14.9543L14.7681 29.1974H15.4712C15.8276 29.1981 16.0357 28.9876 16.0344 28.7013Z"
        fill="#212121"
      />
      <path
        d="M19.0865 30.3727H17.6705L17.3544 30.922H16.5798L18.4895 27.7378H19.335L19.8724 30.922H19.1693L19.0865 30.3727ZM17.9813 29.7854H19.0315L18.8155 28.3198L17.9813 29.7854Z"
        fill="#212121"
      />
      <path
        d="M21.3736 28.6634L20.8899 30.922H20.2153L20.8992 27.7378H21.5929L22.5915 29.9199L23.0613 27.7378H23.7358L23.052 30.922H22.4013L21.3736 28.6634Z"
        fill="#212121"
      />
      <path
        d="M24.025 29.8951C24.2496 30.1915 24.6638 30.3872 25.1011 30.3872C25.4384 30.3872 25.5755 30.1915 25.5742 30.0197C25.5735 29.8286 25.3304 29.7287 25.0309 29.6188C24.5882 29.461 24.0363 29.2512 24.0336 28.6833C24.0316 28.2012 24.4802 27.6904 25.2641 27.6904C25.7677 27.6904 26.2434 27.8769 26.5257 28.2058L26.1096 28.6786C25.885 28.4062 25.4947 28.2731 25.1813 28.2731C24.9202 28.2731 24.74 28.4309 24.7406 28.6073C24.7413 28.7791 24.9845 28.875 25.284 28.9849C25.7266 29.1474 26.2885 29.3618 26.2905 29.9158C26.2931 30.4791 25.8346 30.9805 25.0507 30.9805C24.4285 30.9805 23.8806 30.7368 23.6135 30.3886L24.025 29.8951Z"
        fill="#212121"
      />
      <path
        d="M27.2602 27.7373H28.6285C29.2368 27.7373 29.5946 28.1382 29.5973 28.6203C29.5993 29.093 29.2845 29.7949 28.2913 29.7949H27.4928L27.251 30.9215H26.5764L27.2602 27.7373ZM28.8896 28.6875C28.889 28.4771 28.7312 28.3199 28.4887 28.3199H27.8095L27.6234 29.1982H28.3218C28.6829 29.1982 28.8909 28.9738 28.8896 28.6875Z"
        fill="#212121"
      />
      <path
        d="M31.6165 27.6846C32.4905 27.6846 33.1723 28.2386 33.1763 29.1075C33.1809 30.1483 32.3917 30.9793 31.3461 30.9793C30.4675 30.9793 29.785 30.4253 29.781 29.5517C29.777 28.5103 30.5709 27.6846 31.6165 27.6846ZM31.5767 28.2859C30.9638 28.2859 30.4814 28.8252 30.4847 29.5084C30.4874 30.0478 30.8737 30.3774 31.3819 30.3774C31.9902 30.3774 32.4772 29.838 32.4739 29.1548C32.4712 28.6201 32.0849 28.2859 31.5767 28.2859Z"
        fill="#212121"
      />
      <path
        d="M34.6904 29.7807H34.163L33.9211 30.922H33.2466L33.9304 27.7378H35.2848C35.7976 27.7378 36.2648 28.0814 36.2674 28.6354C36.2701 29.2134 35.8825 29.6475 35.3696 29.7428L35.8122 30.922H35.0661L34.6904 29.7807ZM35.5598 28.7013C35.5584 28.4769 35.3729 28.3191 35.1542 28.3191H34.4797L34.2935 29.1974H34.9965C35.353 29.1981 35.5611 28.9876 35.5598 28.7013Z"
        fill="#212121"
      />
      <path
        d="M37.5152 28.3339H36.5889L36.7194 27.7373H39.2466L39.1214 28.3339H38.195L37.6418 30.9215H36.9626L37.5152 28.3339Z"
        fill="#212121"
      />
      <path
        d="M40.8504 30.3727H39.4344L39.1183 30.922H38.3438L40.2534 27.7378H41.0989L41.6363 30.922H40.9333L40.8504 30.3727ZM39.7458 29.7854H40.7961L40.5801 28.3198L39.7458 29.7854Z"
        fill="#212121"
      />
      <path
        d="M42.8748 28.3339H41.9485L42.079 27.7373H44.6062L44.481 28.3339H43.554L43.0007 30.9215H42.3215L42.8748 28.3339Z"
        fill="#212121"
      />
      <path
        d="M45.0857 27.7373H45.7602L45.0764 30.9215H44.4019L45.0857 27.7373Z"
        fill="#212121"
      />
      <path
        d="M47.7074 27.6846C48.5814 27.6846 49.2632 28.2386 49.2678 29.1075C49.2725 30.1483 48.4833 30.9793 47.4377 30.9793C46.559 30.9793 45.8766 30.4253 45.8726 29.5517C45.8679 28.5103 46.6624 27.6846 47.7074 27.6846ZM47.6676 28.2859C47.0547 28.2859 46.5723 28.8252 46.5756 29.5084C46.5783 30.0478 46.9646 30.3774 47.4728 30.3774C48.0811 30.3774 48.5681 29.838 48.5648 29.1548C48.5621 28.6201 48.1758 28.2859 47.6676 28.2859Z"
        fill="#212121"
      />
      <path
        d="M50.544 28.6634L50.0603 30.922H49.3857L50.0696 27.7378H50.7633L51.7619 29.9199L52.2317 27.7378H52.9062L52.2224 30.922H51.5717L50.544 28.6634Z"
        fill="#212121"
      />
      <path
        d="M36.6853 20.5126C34.0574 20.5126 32.1941 18.3292 32.5234 15.6357C32.8528 12.9422 35.2508 10.7588 37.8787 10.7588C39.3921 10.7588 40.6511 11.4833 41.3846 12.6113L46.1872 7.65184C44.428 5.49573 41.7484 4.15332 38.599 4.15332C32.4572 4.15332 26.8548 9.25594 26.0848 15.5511C25.3149 21.8457 29.6696 26.949 35.8107 26.949C38.9733 26.949 41.9916 25.5946 44.2822 23.4218L40.0269 19.2534C39.0867 20.0345 37.9118 20.5126 36.6853 20.5126Z"
        fill="url(#paint0_linear_4154_49832)"
      />
      <path
        d="M61.3696 0H70.0002L53.9463 25.9492H45.3164L61.3696 0Z"
        fill="url(#paint1_linear_4154_49832)"
      />
      <path
        d="M25.2671 17.0732C25.2638 16.5458 25.2942 16.0105 25.3605 15.4691C25.446 14.7686 25.5884 14.0781 25.7852 13.4022L24.8225 6.22607L19.3274 15.1109L19.77 18.3917H17.2865L14.4446 22.9975H20.3862L20.7812 25.95L27.4676 25.9494L27.1118 23.3025C25.8899 21.5126 25.2545 19.3672 25.2671 17.0732Z"
        fill="url(#paint2_linear_4154_49832)"
      />
      <path
        d="M16.0532 5.16162H24.6837L8.63057 31.1115H0L16.0532 5.16162Z"
        fill="url(#paint3_linear_4154_49832)"
      />
      <path
        d="M49.1719 5.16162H44.2632C45.3208 5.78022 46.271 6.63321 47.1523 7.65134L43.3369 11.5833L45.1359 24.9881L50.6303 16.108L49.1719 5.16162Z"
        fill="url(#paint4_linear_4154_49832)"
      />
    </g>
    <defs>
      <linearGradient
        id="paint0_linear_4154_49832"
        x1="38.5197"
        y1="26.6428"
        x2="34.6283"
        y2="4.68206"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#F26723" />
        <stop offset="0.3315" stop-color="#E35323" />
        <stop offset="0.9971" stop-color="#C61621" />
        <stop offset="1" stop-color="#C61521" />
      </linearGradient>
      <linearGradient
        id="paint1_linear_4154_49832"
        x1="57.6582"
        y1="25.9494"
        x2="57.6582"
        y2="0"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#F26723" />
        <stop offset="0.3315" stop-color="#E35323" />
        <stop offset="0.9971" stop-color="#C61621" />
        <stop offset="1" stop-color="#C61521" />
      </linearGradient>
      <linearGradient
        id="paint2_linear_4154_49832"
        x1="19.9647"
        y1="26.1999"
        x2="29.8582"
        y2="9.14785"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#F26723" />
        <stop offset="0.3315" stop-color="#E35323" />
        <stop offset="0.9971" stop-color="#C61621" />
        <stop offset="1" stop-color="#C61521" />
      </linearGradient>
      <linearGradient
        id="paint3_linear_4154_49832"
        x1="12.342"
        y1="31.1113"
        x2="12.342"
        y2="5.16182"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#F26723" />
        <stop offset="0.3315" stop-color="#E35323" />
        <stop offset="0.9971" stop-color="#C61621" />
        <stop offset="1" stop-color="#C61521" />
      </linearGradient>
      <linearGradient
        id="paint4_linear_4154_49832"
        x1="40.6843"
        y1="22.4058"
        x2="50.307"
        y2="5.82049"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#F26723" />
        <stop offset="0.3315" stop-color="#E35323" />
        <stop offset="0.9971" stop-color="#C61621" />
        <stop offset="1" stop-color="#C61521" />
      </linearGradient>
      <clipPath id="clip0_4154_49832">
        <rect width="70" height="31.1111" fill="white" />
      </clipPath>
    </defs>
  </svg>
</template>
